import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthProvider';

/**
 * Gate for every authenticated route. Renders the nested routes when a session
 * exists, otherwise sends the visitor to /login and remembers where they were
 * headed so SignIn can put them back there.
 *
 * This is a UX gate, not the security boundary — the backend's verifyJWT +
 * verifyPermission are. Nothing here is trusted by the API.
 *
 * It deliberately does NOT handle the bootstrapping window; App holds routing
 * back until the session probe settles, so `isLoggedIn` is already truthful by
 * the time this renders.
 */
const ProtectedRoute = () => {
  const { authState } = useAuthContext();
  const location = useLocation();

  if (!authState?.isLoggedIn) {
    return (
      <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
